document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('NewsletterPopup-newsletter-popup');
    if (!popup) return;

    const enabled = popup.getAttribute('data-enabled') === 'true';
    const delay = parseInt(popup.getAttribute('data-delay')) || 30000;
    const cookieName = 'newsletter_popup_closed';
    const subscribedCookie = 'newsletter_subscribed';

    const isFormSubmitted = window.location.search.includes('customer_posted=true');

    // Check if user already subscribed or closed the popup recently
    if (!isFormSubmitted && (!enabled || getCookie(cookieName) || getCookie(subscribedCookie))) {
        return;
    }

    // Close functionality
    const closeBtn = popup.querySelector('.newsletter-popup__close');
    const container = popup.querySelector('.newsletter-popup__container');

    const closePopup = () => {
        popup.classList.remove('is-visible');
        // Set cookie for 30 days
        setCookie(cookieName, 'true', 30);
    };

    closeBtn.addEventListener('click', closePopup);

    popup.addEventListener('click', (e) => {
        if (!container.contains(e.target)) {
            closePopup();
        }
    });

    if (isFormSubmitted) {
        // Show immediately and set subscribed cookie
        popup.classList.add('is-visible');
        setCookie(subscribedCookie, 'true', 365);

        // Auto-close after 4 seconds
        setTimeout(() => {
            closePopup();
        }, 4000);
    } else {
        // Show popup after delay
        setTimeout(() => {
            popup.classList.add('is-visible');

            // Auto-close after 17 seconds if no input is given
            let autoCloseTimeout = setTimeout(() => {
                closePopup();
            }, 17000);

            const emailInput = popup.querySelector('input[type="email"]');
            if (emailInput) {
                emailInput.addEventListener('input', () => {
                    clearTimeout(autoCloseTimeout);
                }, { once: true });
            }
        }, delay);
    }

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});
